module.exports = "<div class=time>{{time}}</div> <span class=date>{{date}}</span> ";